











































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as modules from "../../../store/decorator";
import headers from "../../data/datatable-headers-history";
import axios from "axios";
import { isOnline } from "../../../utils/services";
import { reject } from "lodash";
import helperFormat from "../../mixins/HelperFormat.vue";

@Component({
    components: {
        vPurchaseOrder: () =>
            import("../../components/shared/VPurchaseOrderSurvey.vue"),
        cctvHistoryIterator: () =>
            import("../../components/shared/CCTVHistoryIterator.vue")
    }
})
export default class SurveyHistory extends Vue {
    @Prop(Object) network!: any;

    @Watch("network.code")
    onNetworkChange(value: string) {
        return this.getHistory(value);
    }

    items: Array<object> = [];
    loading: boolean = false;
    iteratorLoading: boolean = false;
    sheetId: string = "";
    fileData: Array<object> = [];
    search: string = "";

    selectedSurvey = [];
    purchaseOrderNumber: string = "";
    purchaseOrderLoading: boolean = false;

    mounted() {
        this.getHistory();
    }

    get filteredHeaders() {
        if( (modules as any).user.customerAccess.length ) {
            var canViewPO = false;
            const po = (modules as any).user.customerAccess.filter((key: any) => key.code == 'HISTORY.VIEW.PO');
            if (po.length == 0 || po[0].value != 1) {
                canViewPO = false;
            } else {
                canViewPO = true;
            }
            return canViewPO
                ? headers
                : headers.filter(
                    header =>
                        header.value !== "purchaseOrder" &&
                        header.value !== "checkbox"
                );
        } else {
            return headers.filter(
                    header =>
                        header.value !== "purchaseOrder" &&
                        header.value !== "checkbox"
            );
        }
    }

    async setPurchaseOrders() {
        const purchaseOrder = this.purchaseOrderNumber.trim();

        if (this.purchaseOrderNumber !== purchaseOrder) {
            this.purchaseOrderNumber = purchaseOrder;
        }

        if (
            this.selectedSurvey.length > 0 &&
            purchaseOrder.length > 0
        ) {
            this.purchaseOrderLoading = true;
            var ids:any = [];
            this.selectedSurvey.forEach((single:any) => {
                ids.push(single.id);
            });
            await this.$http
                .put(
                    process.env.VUE_APP_V3_SURVEY_UPLOAD_PURCHASES,
                    {
                        ids: ids,
                        purchase: purchaseOrder,
                        status: "AP"
                    },
                    {
                        headers: {
                            Authorization: process.env.VUE_APP_V3_API_KEY
                        }
                    }
                )
                .then(async (res: any) => {
                    this.purchaseOrderLoading = false;
                    this.selectedSurvey = [];
                    this.getHistory();
                })
                .catch((error: any) => modules.root.errorAlert());
        }
    }
    async setPurchaseOrder(props: any) {
        const instance = axios.create();

        const purchaseOrder = this.purchaseOrderNumber.trim();

        if (this.purchaseOrderNumber !== purchaseOrder) {
            this.purchaseOrderNumber = purchaseOrder;
        }

        if (purchaseOrder.length === 0) {
            return;
        }

        await this.$http
            .put(
                `${process.env.VUE_APP_DOT_NET_API_BASE_URL}${
                    process.env.VUE_APP_DOT_NET_API_SURVEY
                }/${props.id}/${props.customerId}/purchase-order/${
                    purchaseOrder
                }`,
                {},
                {
                    headers: {
                        Authorization: process.env.VUE_APP_V3_API_KEY
                    }
                }
            )
            .then(async (res: any) => {
                // this.gmailReceipt(this.purchaseOrderNumber, props);
            })
            .catch((error: any) => modules.root.errorAlert());
    }

    formatRowValue(key: any, value: any) {
        if (key.toLowerCase() == "status") {
            if (value == 0) return "Pending";
            if (value == 1) return "Approved";
            if (value == 2) return "Processing";
            if (value == 3) return "Complete";
            return value;
        } else if (key == "clientContactId") {
            return value
                .replace('["', "")
                .replace('"]', "")
                .replaceAll('","', ", ");
        } else {
            return value;
        }
    }

    get filteredItems() {
        // return (modules as any).user.customerAccess[2].value == "1"
        //   ? this.items.filter((item: any) => item.id !== undefined)
        //   : this.items.filter(
        //       (item: any) =>
        //         item.uploadedBy == modules.user.userDetail.email &&
        //         item.id !== undefined
        //     );
        this.items.forEach(function(single) {
            // @ts-ignore
            if (single.status == "PE") single.status = "0";
            // @ts-ignore
            if (single.status == "AP") single.status = "1";
            // @ts-ignore
            if (single.status == "PR") single.status = "2";
            // @ts-ignore
            if (single.status == "CO") single.status = "3";
        });
        return this.items;
    }

    async getHistory(code: string = this.network.code) {
        this.loading = true;

        return this.$http
            .get(
                `${process.env.VUE_APP_DOT_NET_API_BASE_URL}${
                    process.env.VUE_APP_DOT_NET_API_HISTORY
                }/${modules.user.customerDetail.customerId}/manhole,inflow-ins/${code}`
            )
            .then(response => {
                let singleIndex = 1;
                response.data.forEach((single: any) => {
                    single.row = singleIndex;
                    singleIndex++;
                });
                this.items = response.data;
            })
            .then(response => {
                this.loading = false;
                this.selectedSurvey = [];
            })
            .catch(error => {
                this.loading = false;
                modules.root.snackbar("Please try again later");
            });
    }

    async getDetails(props: any) {
        if (props.expanded) return (props.expanded = false);

        props.expanded = true;

        this.fileData = [];

        this.iteratorLoading = true;

        const instance = axios.create();

        await this.$http
            .get(process.env.VUE_APP_V3_CCTV_UPLOAD_TOKEN, {
                headers: {
                    Authorization: process.env.VUE_APP_V3_API_KEY
                }
            })
            .then(async (googleToken: any) => {
                await instance
                    .get(
                        `https://www.googleapis.com/drive/v3/files?fields=nextPageToken,files(name,size,mimeType,modifiedTime,thumbnailLink,webViewLink,webContentLink,iconLink,videoMediaMetadata/durationMillis,properties)&q=properties+has+{${
                            props.item.uuid === ""
                                ? `key='reticManagerID'+and+value='${
                                      props.item.id
                                  }'}+and+%27${
                                      modules.user.customerDetail.driveId
                                  }%27+in+parents`
                                : `key='referenceNo'+and+value='${
                                      props.item.referenceNo
                                  }'}`
                        }`,
                        {
                            headers: {
                                Authorization: `Bearer ${
                                    googleToken.data.access_token
                                }`
                            }
                        }
                    )
                    .then(response => {
                        this.fileData = response.data;

                        this.iteratorLoading = false;
                    });
            });
    }

    async gmailReceipt(purchaseOrder: string, props: any) {
        let uploadId = props.customerSurveyId
            ? props.customerSurveyId
            : props.item.customerSurveyId;
        let mailSubject = `Purchase Order Added(Manhole) - ${
            modules.user.customerDetail.code
        } - ${modules.user.userDetail.organization} - ID #${uploadId}`;
        let mailHeaders =
            'Content-Type: multipart/mixed; boundary="retic_mailer"\r\n';
        mailHeaders += "MIME-Version: 1.0\r\n";
        mailHeaders += "From: ReticManager Upload<upload@reticmanager.com>\r\n";

        let customerName = modules.user.customerDetail.name;
        let currentDate = Date.now();
        let userOrganization = modules.user.userDetail.organization;
        let userFullName =
            modules.user.userDetail.firstName +
            " " +
            modules.user.userDetail.lastName;
        let cPurchaseOrder = purchaseOrder;

        const instance = axios.create();

        await this.$http
            .get(process.env.VUE_APP_V3_CCTV_UPLOAD_TOKEN, {
                headers: {
                    Authorization: process.env.VUE_APP_V3_API_KEY
                }
            })
            .then(async (googleToken: any) => {
                await this.$http.post(
                    process.env.VUE_APP_V3_CCTV_UPLOAD_SEND_RECEIPT,
                    {
                        mailTo: "upload@reticmanager.com",
                        mailHeaders: mailHeaders,
                        mailSubject: mailSubject,
                        customerName: customerName,
                        uploadId: uploadId,
                        currentDate: currentDate,
                        userOrganization: userOrganization,
                        userFullName: userFullName,
                        cPurchaseOrder: cPurchaseOrder
                    },
                    {
                        headers: {
                            Authorization: process.env.VUE_APP_V3_API_KEY
                        }
                    }
                );
            });
    }
}
